// React Import
import React, { useEffect, useState } from "react";

// Material import

// contants imports

// Component imports
import SubscriptionCard from "../Components/SubscriptionCard";
import axios from "axios";
import { toast } from "react-toastify";
import { CurvedLine, Title } from "../Components/StyledComponents";

const SubscriptionPackages = () => {

  const [packages, setPackages] = useState<any>([]);

  const getPackages = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_NEST_URL}/users/public-plans`,
      )
      .then((response: any) => {
        if (response.data) {
          setPackages(response.data);
        }
      })
      .catch((error) => {
        toast.error('Failed to load plans.');
      });
  }

  useEffect(() => {
    getPackages();
  }, []);

  return (
    <div className="flex flex-col gap-12 items-center mt-24" id='packages'>
      <div className="flex flex-col justify-center items-center gap-4">
        <p className="text-4xl">Ready to simplify your legal journey?</p>
        <p className="text-2xl">Choose your package today and unlock the clarity and support you deserve.</p>
        <p>By subscribing to a EastLaw package, you agree to <a className='font-bold text-primary cursor-pointer hover:underline' onClick={() => { window.open('/terms-of-use', '_blank', 'noopener,noreferrer') }}>our terms</a> and <a className='font-bold text-primary cursor-pointer hover:underline' onClick={() => { window.open('/privacy-policy', '_blank', 'noopener,noreferrer') }}>privacy policy</a>.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 justify-items-center px-6">
        {packages && packages.map((plan: any) => (
          <SubscriptionCard key={plan.name} plan={plan} />
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPackages;
